import AppTextField from "@/components/AppTextField";
import NationChooser from "@/components/NationChooser";
import SendCodeButton from "@/components/SendCodeButton";
import AppLoadingButton from "@/components/mui/LoadingButton";
import API from "@/constant/API";
import { VerifyAction } from "@/constant/VerifyConstant";
import { getTaskId, getUserInfo } from "@/redux/slices/user";
import { dispatch } from "@/redux/store";
import axiosInstance from "@/utils/axios";
import {Box, Divider, InputAdornment, Stack} from "@mui/material";
import { t } from "i18next";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {useTranslation} from "react-i18next";
import classes from "@/pages/security/css/index.module.less";
import {enqueueSnackbar} from "notistack";
import SimpleHeader from "../components/Headers/SimpleHeader";
import { KYC_STATUS } from "@/constant/Constant";
import RouteConstant from "@/constant/RouteConstant";
import NationSelect from "@/components/NationSelect";

function SecurityMobileBind() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);
  const [loading, setLoading] = useState(false);

  const [mobile, setMobile] = useState('');
  const [code, setCode] = useState('');

  const [step, setStep] = useState(1);  // 1 mobile exist  2 Bind mobile
  const [tokenModel, setTokenModel] = useState(null);
  const [nationRecord, setNationRecord] = useState(null);
  const [nationCode, setNationCode] = useState(null);

  const handleSubmit = async (evt) => {
    evt.preventDefault();

    try {
      setLoading(true);

      if (step == 1) {
        const params = {
          mobile: mobile,
          nationCode: nationCode,
        };
        const tokenModel = await axiosInstance.post(API.BIND_MOBILE_EXIST, params);
        setTokenModel(tokenModel);
        setStep(2);
      } else {
        const params = {
          mobile: mobile,
          nationCode: nationCode,
          code: code,
          sign: tokenModel.sign,
          taskId: getTaskId(),
        };
        await axiosInstance.post(API.BIND_MOBILE, params);
        // TODO: toast 提示用户修改mobile成功
        enqueueSnackbar(t('successful'), { variant: 'success' })
        dispatch(getUserInfo());


        // 检查用户是否还在向导步骤(kyc未提交)，返回home
        if (user.kycStatus === KYC_STATUS.KYC_STATUS_NOT_SUBMIT) {
          navigate(RouteConstant.HOME, { 
            replace: true,
          });
        } else {
          navigate(-1);
        }
      }
    } finally {
      setLoading(false);
    }
  }

  const _onMobileChange = (evt) => {
    setMobile(evt.target.value);
    setStep(1);
  }

  const onNationCodeChange = function(val) {
    setNationRecord(val);
    setNationCode(val.areaCode);
  };

  if (!user) return null;

  return (<>
    <SimpleHeader />
    <Box className={classes["security-wrap"]}>
      <Box className={classes["security-title-wrap"]}>
        <div className={classes["security-title"]}>{t('mobile_bind')}</div>
      </Box>
      <form autoComplete="off" onSubmit={handleSubmit}>
        <Box className={classes["column-gap-wrap"]}>
          <AppTextField
            label={t('mobile')}
            placeholder={t('mobile')}
            onChange={_onMobileChange}
            required
            value={mobile}
            fullWidth
            clearable
            onClear={() => setMobile('')}
            InputProps={{
              startAdornment:
                <InputAdornment position="start">
                  <Stack direction="row" alignItems="center">
                    <NationSelect isBindMobile={true} variant='borderless' isCompact={true} selected={nationRecord} onSelect={onNationCodeChange} />
                    <Divider sx={{ height: '20px' }} orientation="vertical"  />
                  </Stack>
                  </InputAdornment>
            }}
          />
          {step == 2 && <AppTextField
            label={t('code')}
            placeholder={t('code')}
            onChange={(e) => setCode(e.target.value.trim())}
            required
            value={code}
            fullWidth
            // clearable
            // onClear={() => setCode('')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SendCodeButton
                    btnText={t('send_code')}
                    action={VerifyAction.BIND_SMS}
                    enable={true}
                    type={0}
                    params={{
                      mobile: mobile,
                      nationCode: nationCode,
                    }}
                    onError={(error)=>{
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />}
        </Box>
      </form>
      <Box className={classes["fixed-button"]}>
        <AppLoadingButton
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          onClick={handleSubmit}
        >
          {t('confirm')}
        </AppLoadingButton>
      </Box>
    </Box>
  </>);
}

export default SecurityMobileBind;
